var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 59,
    viewBox: "0 0 61 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3616",
    "data-name": "Group 3616",
    transform: "translate(0.472 0.007)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 30.5,
    cy: 29.5,
    rx: 30.5,
    ry: 29.5,
    transform: "translate(-0.472 -0.007)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "comment_10_",
    "data-name": "comment (10)",
    d: "M19.675,2.758A12,12,0,1,0,12.018,24H19a5.006,5.006,0,0,0,5-5V11.246a12.044,12.044,0,0,0-4.325-8.488ZM8,7h4a1,1,0,0,1,0,2H8A1,1,0,0,1,8,7Zm8,10H8a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Zm0-4H8a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Z",
    transform: "translate(18.508 17.996)",
    fill: "#00b1ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.a6c4f250a294d21d1adca2073a29a346.svg";
export { ForwardRef as ReactComponent };